import { BUTTON_SIZES } from "components/DesignComponents/Button";
import CopyButton from "components/DesignComponents/CopyButton";

import { CardItemValueProps } from "./types";

const CardItemValue = ({ value }: CardItemValueProps) => {
    return value !== null && value !== undefined ? (
        <span>
            {value}
            <CopyButton size={BUTTON_SIZES.Tiny} copiedValue={String(value)} />
        </span>
    ) : (
        <span>-</span>
    );
};

export default CardItemValue;
